<div class="carousel">
  <div class="carousel-inner">
    <div class="carousel-item"></div>
    <div class="carousel-item"></div>
    <div class="carousel-item"></div>
    <div class="carousel-item"></div>
  </div>
</div>

<style>
  .carousel {
    width: 100%;
    height: 50vh;
    overflow: hidden;
    position: relative;
  }

  .carousel-inner {
    display: flex;
    width: 400%;
    height: 100%;
    animation: slide 20s infinite;
  }

  .carousel-item {
    width: 25%;
    flex: 1 0 auto;
    height: 100%;
  }

  .carousel-item:nth-child(1) { background-image: url('/wedding1.jpg'); }
  .carousel-item:nth-child(2) { background-image: url('/wedding2.jpg'); }
  .carousel-item:nth-child(3) { background-image: url('/wedding3.jpg'); }
  .carousel-item:nth-child(4) { background-image: url('/wedding1.jpg'); }

  .carousel-item {
    background-size: cover;
    background-position: center;
  }

  @keyframes slide {
    0% { transform: translateX(0); }
    20% { transform: translateX(0); }
    25% { transform: translateX(-25%); }
    45% { transform: translateX(-25%); }
    50% { transform: translateX(-50%); }
    70% { transform: translateX(-50%); }
    75% { transform: translateX(-75%); }
    95% { transform: translateX(-75%); }
    100% { transform: translateX(0); }
  }
</style>
